
function anglesToRadians(angle) {return (Math.PI/180 * angle)};

export default anglesToRadians;